import { render, staticRenderFns } from "./NewWRModal.vue?vue&type=template&id=4ee0ce3d&scoped=true&"
import script from "./NewWRModal.vue?vue&type=script&lang=js&"
export * from "./NewWRModal.vue?vue&type=script&lang=js&"
import style0 from "./NewWRModal.vue?vue&type=style&index=0&id=4ee0ce3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee0ce3d",
  null
  
)

export default component.exports